import React from "react";

import ExecutorNoteCellContent from "../components/ExecutorNoteCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function executorNote({ width, onResize }: Column.Options) {
	return base(
		ColumnId.ExecutorNote,
		(item) => <ExecutorNoteCellContent item={item} />,
		{
			width,
			sortable: false,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default executorNote;
